/** Default label/icon/color for each `type` prop value (merged across apps). */
export type ActionButtonTypeConfig = {
  text: string
  icon: string
  color: string
}

export function resolveActionButtonType(
  type: string,
  t: (key: string) => string,
): ActionButtonTypeConfig {
  switch (type) {
    case "add_to_participant":
      return {
        text: t("enrolments.add_to_participant"),
        icon: "fas fa-check-square",
        color: "info",
      }
    case "approve":
      return {
        text: t("global.approve"),
        icon: "fas fa-check",
        color: "success",
      }
    case "back":
      return {
        text: t("global.back"),
        icon: "fas fa-arrow-left",
        color: "info",
      }
    case "cancel":
      return {
        text: t("global.cancel"),
        icon: "fas fa-ban",
        color: "info",
      }
    case "check_in":
      return {
        text: t("checkin.check_in_btn"),
        icon: "fas fa-check-square",
        color: "success",
      }
    case "clear":
      return {
        text: t("global.clear"),
        icon: "fas fa-minus-square",
        color: "info",
      }
    case "close":
      return {
        text: t("global.close"),
        icon: "fas fa-times",
        color: "error",
      }
    case "copy":
      return {
        text: t("global.copy"),
        icon: "fas fa-copy",
        color: "info",
      }
    case "course_reg_form":
      return {
        text: t("courses.register_link"),
        icon: "fas fa-link",
        color: "info",
      }
    case "crop":
      return {
        text: t("global.upload"),
        icon: "fas fa-crop-alt",
        color: "info",
      }
    case "default":
      return { text: "", icon: "", color: "info" }
    case "delete":
      return {
        text: t("global.delete"),
        icon: "fas fa-trash",
        color: "error",
      }
    case "did_not_meet":
      return {
        text: t("checkin.did_not_meet_btn"),
        icon: "fas fa-minus-square",
        color: "warning",
      }
    case "download":
      return {
        text: t("global.download"),
        icon: "fas fa-download",
        color: "info",
      }
    case "edit":
      return {
        text: t("global.edit"),
        icon: "fas fa-edit",
        color: "info",
      }
    case "export_excel":
      return {
        text: t("global.export_excel"),
        icon: "fas fa-file-excel",
        color: "info",
      }
    case "filter":
      return {
        text: t("global.filter"),
        icon: "fas fa-filter",
        color: "info",
      }
    case "find":
      return {
        text: t("global.find"),
        icon: "fas fa-search",
        color: "info",
      }
    case "import":
      return {
        text: t("global.import"),
        icon: "fas fa-file-import",
        color: "info",
      }
    case "merge":
      return {
        text: t("global.merge"),
        icon: "fas fa-object-group",
        color: "info",
      }
    case "move":
      return {
        text: t("global.move"),
        icon: "fas fa-file-import",
        color: "info",
      }
    case "new":
      return {
        text: t("global.new"),
        icon: "fas fa-plus",
        color: "success",
      }
    case "notify":
      return {
        text: t("global.notify"),
        icon: "fas fa-paper-plane",
        color: "success",
      }
    case "pdf":
      return {
        text: t("global.pdf"),
        icon: "fas fa-pdf",
        color: "info",
      }
    case "permission":
      return {
        text: t("permissions.title"),
        icon: "vpn_key",
        color: "info",
      }
    case "preview":
      return {
        text: t("global.preview"),
        icon: "fas fa-eye",
        color: "info",
      }
    case "qrcode":
      return {
        text: t("global.qrcode"),
        icon: "fas fa-qrcode",
        color: "info",
      }
    case "remove":
      return {
        text: t("global.remove"),
        icon: "fas fa-minus",
        color: "error",
      }
    case "reset":
      return {
        text: t("global.reset"),
        icon: "fas fa-sync",
        color: "info",
      }
    case "restore":
      return {
        text: t("global.restore"),
        icon: "fas fa-trash-restore",
        color: "warning",
      }
    case "reject":
      return {
        text: t("global.reject"),
        icon: "fas fa-times",
        color: "error",
      }
    case "role":
      return {
        text: t("roles.title"),
        icon: "recent_actors",
        color: "info",
      }
    case "run_report":
      return {
        text: t("reports.run_report"),
        icon: "fas fa-check-circle",
        color: "success",
      }
    case "save":
      return {
        text: t("global.save"),
        icon: "fas fa-save",
        color: "success",
      }
    case "save_and_send":
      return {
        text: t("global.save_send"),
        icon: "fas fa-paper-plane",
        color: "success",
      }
    case "save_without_notification":
      return {
        text: t("global.save_without_notification"),
        icon: "fas fa-save",
        color: "success",
      }
    case "search":
      return {
        text: t("global.search"),
        icon: "fas fa-search",
        color: "info",
      }
    case "select":
      return {
        text: t("global.select"),
        icon: "fas fa-check-square",
        color: "success",
      }
    case "send":
      return {
        text: t("global.send"),
        icon: "fas fa-paper-plane",
        color: "success",
      }
    case "show_filter":
      return {
        text: t("global.show_filter"),
        icon: "fas fa-filter",
        color: "info",
      }
    case "submit":
      return {
        text: t("global.submit"),
        icon: "fas fa-save",
        color: "success",
      }
    case "switchcamera":
      return {
        text: t("global.switchcamera"),
        icon: "fas fa-camera",
        color: "warning",
      }
    case "sync":
      return {
        text: t("global.sync"),
        icon: "fas fa-sync",
        color: "info",
      }
    case "upload":
      return {
        text: t("global.upload"),
        icon: "fas fa-paperclip",
        color: "info",
      }
    case "validate":
      return {
        text: t("global.validate"),
        icon: "fas fa-share-square",
        color: "success",
      }
    case "view":
      return {
        text: t("global.view"),
        icon: "fas fa-eye",
        color: "info",
      }
    default:
      return { text: "", icon: "", color: "info" }
  }
}
